const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const logInvalidScanEvent = async () => {
  try {
    // Make a POST request to log the invalid scan event
    const response = await fetch(`${API_BASE_URL}/api/v1/logs/log-invalid-scan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
        console.warn("Logging scan event failed with status:", response.status);
    }
  } catch (error) {
    console.error("Failed to log scan event:", error);
  }
};
